// extracted by mini-css-extract-plugin
export var container = "_17-0";
export var icon = "_17-1";